const meta = {
  home: 'Team and collection home pages',
  migration: 'Migrate from buckets',
};

export default meta;
